{
  "maximum": "Maksimālā vērtība",
  "minimum": "Minimālā vērtība"
}
